import React, { Component, useEffect, useState } from 'react';
import lodash from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import CreateFeedItemSearchGroup from '../Feed/CreateFeedItem/CreateFeedItemSearchGroup';
import CreateFeedItemSelectedGroup from '../Feed/CreateFeedItem/CreateFeedItemSelectedGroup';
import CreateFeedItemHighFive from '../Feed/CreateFeedItem/CreateFeedItemHighFive';

import GroupApi from '../../api/group';
import { createHighFiveRequest } from '../../actionCreators/feedActions';
import { useNavigate } from 'react-router-dom';

const SendHighFive = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState({
    selectedGroupId: '',
    showErrors: '',
    groups: props.groups || [],
  });

  useEffect(() => {
    GroupApi.getMyAndColleagueGroups(props.userId, props.selectedColleague.id).then((groups) => {
      setLoading(false);
      setState({ ...state, groups: groups.groups || [] });
    });
  }, []);

  const onSelect = (selectedGroupId) => {
    setState({ ...state, selectedGroupId: selectedGroupId });
  };

  const onSubmit = (type, data) => {
    if (!state.selectedGroupId) return setState({ showErrors: true });
    if (!data.recipient_id || !data.highfive_type_id || (data.reason && data.reason.error)) {
      return setState({ ...state, showErrors: true });
    }

    if (data.reason) data.reason = data.reason.value;
    data.group_id = state.selectedGroupId;
    props.createHighFive(data);

    // Go to home page - feed
    navigate('/');

    return props.close();
  };

  const checkFields = (type, data) => {
    if (!state.selectedGroupId) return false;
  
    if (type === 'High Five') {
      if (!data.recipient_id || !data.highfive_type_id) {
        return false;
      }
    }
  
    return true;
  };

  const onInputFocus = (stateData = state) => {
    if (stateData.isFocused) return;

    setState({ ...stateData, isFocused: true });
    if (typeof props.onToggleActive === 'function') props.onToggleActive(true);
  };

  if (loading) {
    return <p>loading...</p>;
  } else {
    const { selectedGroupId, showErrors } = state;

    let groupRowEl = null;
    if (!selectedGroupId) {
      groupRowEl = (
        <CreateFeedItemSearchGroup
          onSelect={onSelect}
          groups={state.groups}
          showError={showErrors}
          activeTab='Notice'
          featureFlags={props.featureFlags}
          isActive={state.isFocused}
          onFocus={onInputFocus}
        />
      );
    } else {
      const selectedGroup = lodash.find(state.groups, { id: selectedGroupId });
      if (selectedGroup) {
        groupRowEl = (
          <CreateFeedItemSelectedGroup
            group={selectedGroup}
            onCancel={() => setState({ ...state, selectedGroupId: '' })}
          />
        );
      }
    }

    return (
      <div className="create-feed feed">
        <div className="create-feed-holder w-100">
          <div className="create-feed-content">
            {groupRowEl}

            <CreateFeedItemHighFive
              onSubmit={onSubmit}
              selectedGroupId={selectedGroupId}
              showErrors={showErrors}
              selectedColleague={props.selectedColleague}
              disallowEditColleague
              checkFields={checkFields}
            />
          </div>
        </div>
      </div>
    );
  }
};

const SendHighFiveContainer = (props) => {
  const state = useSelector((state) => ({
    userId: state.currentUser.userData.id,
    featureFlags: state.featureFlags,
  }));

  const dispatch = useDispatch();

  const actions = {
    createHighFive: (payload) => dispatch(createHighFiveRequest(payload)),
  };

  return <SendHighFive {...props} {...state} {...actions} />;
};

export default SendHighFiveContainer;
